

































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IAssessment, IAssessmentOutputs } from "../store/main.interfaces";
import QuickAssistant from "../components/quick-assistant.vue";
import assessments from "../store/modules/assessments";
import BubbleChart from "../components/bubblechart.vue";
import {
  vocalizeBenefitSuitability,
  vocalizeBenefitSuitabilityAverage,
  vocalizeEaseOfImplementation,
  vocalizeEaseOfImplementationAverage,
  vocalizeEffortToImplement,
  vocalizeEffortToImplementAverage
} from "../store/assessment.render";
import { isMobile } from "../utils/device.utils";
import ImplementationMotivator, {
  Action as ImplementationMotivatorAction
} from "../components/implementation-motivator.vue";
import { messages } from "../store/textData";
import VueI18n from "vue-i18n";
import { COLORS } from "@/colors";
import BarChart from "@/components/barchart.vue";
import xlsx from "xlsx";
import { saveAs } from "file-saver";
import user from "../store/modules/user";
import { exportAssessmentList } from "../store/excel-util";

@Component({
  components: { BarChart, BubbleChart, QuickAssistant, ImplementationMotivator }
})
export default class ComparisonView extends Vue {
  @Prop() assessmentEntries!: IAssessment[];
  @Prop() editableAssessment!: IAssessment;
  @Prop() editableAssessmentIndex!: number;
  createAssessmentDialog: boolean = false;
  downloadAssessmentListDialog: boolean = false;
  language: string = "de";
  implementationFilter: boolean = false;
  groupBy: string | null = null;
  hoveredChartItem: IAssessment[] = [];
  hoveredTableItem: IAssessment | null = null;
  selectedItemId: string | null = null;
  closedGroups: string[] = [];
  itemToExport!: IAssessment;

  @Watch("$route.params.userName")
  onParameterChange() {
    this.loadAssessments();
  }

  get dialogWidth() {
    return isMobile() ? "100vw" : "80vw";
  }

  filterAssessmentList() {
    if (this.implementationFilter === true) {
      const filteredAssessmentList = this.assessmentEntries.filter(
        assessment => assessment.implemented === true
      );
      return filteredAssessmentList;
    } else {
      return this.assessmentEntries;
    }
  }
  getFilterText() {
    if (this.implementationFilter === true)
      return this.$t("views.comparisonView.implemented");
    else return this.$t("views.comparisonView.allProcesses");
  }
  getFilterIcon() {
    if (this.implementationFilter === true) return "mdi-playlist-check";
    else return "mdi-playlist-edit";
  }

  getResolveIcon(assessment: IAssessment) {
    if (assessment) {
      if (assessment.implemented === false) {
        return "mdi-check";
      } else {
        return "mdi-close-circle";
      }
    }
  }

  multipleAssessmentExport(assessmentList: IAssessment[]) {
    exportAssessmentList(assessmentList);
    this.downloadAssessmentListDialog = false;
  }

  async loadAssessments() {
    if (this.$route.params.userName) {
      await assessments.getSpecificUserAssessments(this.$route.params.userName);
    } else {
      await assessments.refreshAssessments();
    }
  }


  openAssessmentListExportDialog() {
    this.downloadAssessmentListDialog = true;
  }


  

  async mounted() {
    this.loadAssessments();
    assessments.refreshDepartments();
  }

  data() {
    return {
      dialog: false,
      dialogText: 0,
      editDialog: false,
      highlightedColor: "cadetblue",
      headers: [
        {
          text: this.$tc("generics.terms.process", 1),
          align: "start",
          value: "name",
          sortable: false,
          explanation: this.$t("views.comparisonView.tooltips.nameOfProcess")
        },
        {
          text: this.$t("generics.terms.freedCapacity"),
          value: "outputs.bandwidthFreed",
          align: "center",
          explanation: this.$t("views.comparisonView.tooltips.freedCapacity")
        },
        {
          text: this.$t("generics.terms.errorReduction"),
          value: "outputs.errorReduction",
          align: "center",
          explanation: this.$t("views.comparisonView.tooltips.errorReduction")
        },
        {
          text: this.$t("generics.terms.effortToImplement"),
          value: "outputs.effortToImplement",
          align: "center",
          explanation: this.$t("views.comparisonView.tooltips.effortToImplement")
        },
        {
          text: this.$t("generics.terms.easeOfImplementation"),
          value: "outputs.easeOfImplementation",
          align: "center",
          explanation: this.$t("views.comparisonView.tooltips.easeOfImplementation")
        },
        {
          text: this.$t("generics.terms.benefit"),
          value: "outputs.benefitSuitability",
          align: "center",
          explanation: this.$t("views.comparisonView.tooltips.benefit")
        }
      ]
    };
  }

  sum(assessments: IAssessment[], key: keyof IAssessmentOutputs) {
    let displayResult;
    let sum = 0;
    assessments.forEach(
      assessment => (sum += (assessment.outputs[key] || 0) as number)
    );
    switch (key) {
      case "bandwidthFreed":
        displayResult = this.showBandwidthFreed(sum);
        break;
      case "effortToImplement":
        displayResult = vocalizeEffortToImplementAverage(sum);
        break;
    }
    return displayResult;
  }

  average(assessments: IAssessment[], key: keyof IAssessmentOutputs) {
    let displayResult;
    let sum = 0;
    assessments.forEach(
      assessment => (sum += (assessment.outputs[key] || 0) as number)
    );
    const value = sum / assessments.length;
    switch (key) {
      case "easeOfImplementation":
        displayResult = vocalizeEaseOfImplementationAverage(value);
        break;
      case "benefitSuitability":
        displayResult = vocalizeBenefitSuitabilityAverage(value);
        break;
      case "errorReduction":
        displayResult = this.showErrorReduction(value);
        break;
      case "effortToImplement":
        displayResult = vocalizeEffortToImplementAverage(value);
        break;
    }
    return displayResult;
  }

  showEaseOfImplementation(assessment: IAssessment) {
    return vocalizeEaseOfImplementation(assessment);
  }

  showBenefitSuitability(assessment: IAssessment) {
    return vocalizeBenefitSuitability(assessment);
  }

  showBandwidthFreed(value: number) {
    if (isNaN(value) || typeof value !== "number") {
      return 0;
    } else {
      return value.toFixed(1) + "h";
    }
  }

  showErrorReduction(value: number) {
    if (typeof value === "number") {
      return value.toFixed(1) + "%";
    } else {
      return 0 + "%";
    }
  }

  showEffortToImplement(assessment: IAssessment) {
    return vocalizeEffortToImplement(assessment);
  }

  changeGroupBy() {
    this.groupBy = this.groupBy === "department" ? null : "department";
  }

  getDepartments(): string[] {
    const departments = new Set<string>();
    let hasNoDepartment: boolean = false;
    this.assessmentEntries.forEach(entry => {
      if (entry.department) {
        departments.add(entry.department);
      } else {
        hasNoDepartment = true;
      }
    });
    return hasNoDepartment
      ? [this.$t('generics.terms.noDepartment') as string, ...Array.from(departments).sort()]
      : [...Array.from(departments).sort()];
  }

  getColorOfDepartment(department: string, isGroupHeader: boolean): string {
    const departments = this.getDepartments();
    if (!department || department === "null") {
      department = this.$t('generics.terms.noDepartment') as string;
    }
    const index = departments.indexOf(department);
    const colorValues = this.getColorValues(COLORS[index]);
    return isGroupHeader
      ? "background-color:" + COLORS[index]
      : "--tr_color: rgba(" +
          colorValues[0] +
          "," +
          colorValues[1] +
          "," +
          colorValues[2] +
          ", 0.1); --tr_color_hover_selected: rgba(" +
          colorValues[0] +
          "," +
          colorValues[1] +
          "," +
          colorValues[2] +
          ", 0.3);";
  }

  getColorValues(color: string): string[] {
    const colorString = color,
      colorValues = colorString
        .substring(colorString.indexOf("(") + 1, colorString.lastIndexOf(")"))
        .split(/,\s*/);

    return colorValues;
  }

  toggleGroupedRows(department: string) {
    if (!department || department === "null") {
      department = this.$t('generics.terms.noDepartment') as string;
    }
    const groupIsClosed = this.closedGroups.includes(department);
    if (groupIsClosed) {
      const index = this.closedGroups.indexOf(department);
      this.closedGroups.splice(index, 1);
    } else {
      this.closedGroups.push(department);
    }
  }

  checkToggledGroups(department: string): boolean {
    if (!department || department === "null") {
      department = this.$t('generics.terms.noDepartment') as string;
    }
    return this.closedGroups.includes(department);
  }

  openQuickAssistant() {
    this.createAssessmentDialog = true;
  }

  onRowClicked(item: IAssessment) {
    if (this.selectedItemId === item.id) {
      this.selectedItemId = null;
    } else {
      this.selectedItemId = item.id || null;
    }
  }

  onImplementationMotivatorCta(action: ImplementationMotivatorAction) {
    if (action === ImplementationMotivatorAction.OPEN_QUICK_ASSISTANT) {
      this.openQuickAssistant();
    }
  }

  mouseoverChartData(data: IAssessment | string) {
    if (typeof data === "string") {
      const item = this.assessmentEntries.find(entry => entry.id === data);
      if (item) {
        this.hoveredChartItem.push(item);
        this.hoveredTableItem = item;
      }
    } else {
      this.hoveredChartItem.push(data);
      this.hoveredTableItem = data;
    }
  }

  mouseoutChartData(data: IAssessment | string) {
    let index = -1;
    if (typeof data === "string") {
      const item = this.assessmentEntries.find(entry => entry.id === data);
      if (item) {
        index = this.hoveredChartItem.indexOf(item);
      }
    } else {
      index = this.hoveredChartItem.indexOf(data);
    }
    this.hoveredChartItem.splice(index, 1);
    this.hoveredTableItem = null;
  }

  mouseover(item: IAssessment) {
    this.hoveredTableItem = item;
  }

  mouseout(item: IAssessment) {
    this.hoveredTableItem = null;
  }
}
